import { useGrowthBook } from '@growthbook/growthbook-react';
import { Fragment, PropsWithChildren, useEffect } from 'react';
import useAuth from '@/data/hook/useAuth';

export default function GrowthBookSetUserAttributes({
  children,
}: PropsWithChildren) {
  const { user } = useAuth();
  const growthBook = useGrowthBook();

  useEffect(() => {
    if (user?.id && growthBook) {
      growthBook.setAttributes({
        ...growthBook.getAttributes(),
        userId: user.id,
        userType: user.userType,
        unitsIds: user.unitsIds,
      });
    }
  }, [user, growthBook]);

  return <Fragment>{children}</Fragment>;
}
